var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from 'react';
import { Button, Form as UIForm } from 'semantic-ui-react';
import { useAccessToken } from '~/AccessToken';
import { isPasswordTooBig, PasswordLoginError, PasswordLoginRequest, PasswordMinLength, } from '~/Api/Authentication';
import { useApi } from '~/ApiHooks';
var ValidationError;
(function (ValidationError) {
    ValidationError[ValidationError["deactivatedAccount"] = 0] = "deactivatedAccount";
    ValidationError[ValidationError["expiredAccount"] = 1] = "expiredAccount";
    ValidationError[ValidationError["passwordsMissmatch"] = 2] = "passwordsMissmatch";
    ValidationError[ValidationError["passwordTooBig"] = 3] = "passwordTooBig";
    ValidationError[ValidationError["passwordTooShort"] = 4] = "passwordTooShort";
    ValidationError[ValidationError["unknownEmail"] = 5] = "unknownEmail";
})(ValidationError || (ValidationError = {}));
var emailErrorText = function (error, contact) {
    switch (error) {
        case ValidationError.unknownEmail:
            return 'Zkontrolujte zda jste zadali správný email';
        case ValidationError.deactivatedAccount:
            return "V\u00E1\u0161 \u00FA\u010Det nen\u00ED aktivn\u00ED, kontaktujte pros\u00EDm ".concat(contact);
        case ValidationError.expiredAccount:
            return "V\u00E1\u0161 \u00FA\u010Det ji\u017E nen\u00ED aktivn\u00ED, kontaktujte pros\u00EDm ".concat(contact);
        default:
            return null;
    }
};
var passwordErrorText = function (error, minPasswordLength) {
    switch (error) {
        case ValidationError.passwordsMissmatch:
            return 'Neplatné heslo, zkuste to prosím znovu';
        case ValidationError.passwordTooShort:
            return "Heslo mus\u00ED m\u00EDt alespo\u0148 ".concat(minPasswordLength, " znak\u016F");
        case ValidationError.passwordTooBig:
            return 'Heslo je moc dlouhé';
        default:
            return null;
    }
};
var Form = function (_a) {
    var contact = _a.contact, disabled = _a.disabled, error = _a.error, minLength = _a.minLength, values = _a.values, onChange = _a.onChange, onSubmit = _a.onSubmit;
    var submit = function (event) {
        event.preventDefault();
        if (event.currentTarget.reportValidity()) {
            onSubmit();
        }
    };
    return (<UIForm noValidate size='large' onSubmit={submit}>
			<UIForm.Input autoFocus fluid required data-testid='email-input' disabled={disabled} error={error !== null ? emailErrorText(error, contact) : null} icon='user' iconPosition='left' label='Email' placeholder='me@example.com' type='email' onChange={function (event) {
            onChange(__assign(__assign({}, values), { email: event.target.value }));
        }}/>
			<UIForm.Input fluid required data-testid='password-input' disabled={disabled} error={error !== null ? passwordErrorText(error, minLength) : null} icon='lock' iconPosition='left' label='Heslo' type='password' onChange={function (event) {
            onChange(__assign(__assign({}, values), { password: event.target.value }));
        }}/>
			<Button data-testid='login-button' disabled={disabled} size='large'>
				Přihlásit se
			</Button>
		</UIForm>);
};
export var Login = function (_a) {
    var contact = _a.contact, _b = _a.minLength, minLength = _b === void 0 ? PasswordMinLength : _b, PasswordResetLink = _a.PasswordResetLink, onComplete = _a.onComplete;
    var _c = React.useState({ email: '', password: '' }), values = _c[0], setValues = _c[1];
    var _d = React.useState(null), validationError = _d[0], setValidationError = _d[1];
    var _e = useApi(), login = _e[0], result = _e[1];
    var _f = useAccessToken(), setAccessToken = _f[2];
    var valuesChanged = function (values) {
        setValues(values);
        setValidationError(null);
    };
    var submit = function () { return __awaiter(void 0, void 0, void 0, function () {
        var error, response;
        var _a, _b, _c, _d, _e, _f, _g, _h;
        return __generator(this, function (_j) {
            switch (_j.label) {
                case 0:
                    error = Array.from(values.password).length < minLength
                        ? ValidationError.passwordTooShort
                        : isPasswordTooBig(values.password)
                            ? ValidationError.passwordTooBig
                            : null;
                    setValidationError(error);
                    if (error !== null) {
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, login(new PasswordLoginRequest(values.email.trim(), values.password))];
                case 1:
                    response = _j.sent();
                    if (response.value !== null) {
                        setAccessToken(response.value.accessToken);
                        onComplete(response.value);
                    }
                    else if ((_b = (_a = response.error) === null || _a === void 0 ? void 0 : _a.has(PasswordLoginError.userNotFound)) !== null && _b !== void 0 ? _b : false) {
                        setValidationError(ValidationError.unknownEmail);
                    }
                    else if ((_d = (_c = response.error) === null || _c === void 0 ? void 0 : _c.has(PasswordLoginError.passwordMissmatch)) !== null && _d !== void 0 ? _d : false) {
                        setValidationError(ValidationError.passwordsMissmatch);
                    }
                    else if ((_f = (_e = response.error) === null || _e === void 0 ? void 0 : _e.has(PasswordLoginError.deactivatedAccount)) !== null && _f !== void 0 ? _f : false) {
                        setValidationError(ValidationError.deactivatedAccount);
                    }
                    else if ((_h = (_g = response.error) === null || _g === void 0 ? void 0 : _g.has(PasswordLoginError.expiredAccount)) !== null && _h !== void 0 ? _h : false) {
                        setValidationError(ValidationError.expiredAccount);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    return (<>
			<Form contact={contact} disabled={result.isLoading} error={validationError} minLength={minLength} values={values} onChange={valuesChanged} onSubmit={submit}/>
			<p>
				Zapoměli jste své heslo?{' '}
				<PasswordResetLink>
					<a>Nastavte si nové</a>
				</PasswordResetLink>
				.
			</p>
		</>);
};
Login.displayName = 'Password.Login';
